import { Link } from "react-router-dom";
import trustBadge from "@/assets/trust-badge.webp";

export function TrustStrip() {
  return (
    <section className="border-y bg-muted/40">
      <div className="container mx-auto flex flex-col items-center gap-5 px-4 py-8 text-center md:flex-row md:gap-8 md:text-left">
        <img
          src={trustBadge}
          alt="Raise Sri Lanka — registered 501(c)(3) nonprofit"
          width={88}
          height={88}
          className="h-20 w-20 flex-shrink-0"
        />
        <div className="flex-1">
          <h2 className="font-display text-xl font-semibold md:text-2xl">
            100% of your donation funds projects in Sri Lanka.
          </h2>
          <p className="mt-1 text-sm text-muted-foreground md:text-base">
            We're 100% volunteer-run. Founders and volunteers cover operating
            costs, so every dollar you give reaches a family on the ground.{" "}
            <Link to="/transparency" className="font-medium text-primary underline-offset-4 hover:underline">
              See where every dollar goes →
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
